export default function A2PBadgeIcon() {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.5 3C7.02069 3.03917 8.50695 2.54375 9.7 1.6C9.77428 1.54429 9.86262 1.51036 9.9551 1.50202C10.0476 1.49368 10.1406 1.51126 10.2236 1.55279C10.3067 1.59431 10.3765 1.65815 10.4253 1.73713C10.4741 1.81612 10.5 1.90714 10.5 2V8C10.5 8.09286 10.4741 8.18388 10.4253 8.26287C10.3765 8.34185 10.3067 8.40569 10.2236 8.44721C10.1406 8.48874 10.0476 8.50632 9.9551 8.49798C9.86262 8.48964 9.77428 8.45571 9.7 8.4C8.50695 7.45625 7.02069 6.96083 5.5 7H2.5C2.23478 7 1.98043 6.89464 1.79289 6.70711C1.60536 6.51957 1.5 6.26522 1.5 6V4C1.5 3.73478 1.60536 3.48043 1.79289 3.29289C1.98043 3.10536 2.23478 3 2.5 3H5.5Z'
        stroke='#D97706'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3 7C3 8.29822 3.42107 9.56142 4.2 10.6C4.35913 10.8122 4.59603 10.9524 4.85858 10.9899C5.12113 11.0275 5.38783 10.9591 5.6 10.8C5.81217 10.6409 5.95244 10.404 5.98995 10.1414C6.02746 9.87887 5.95913 9.61217 5.8 9.4C5.28071 8.70761 5 7.86548 5 7'
        stroke='#D97706'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M4 3V7' stroke='#D97706' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
